<div class="card" id="recent-payments">
    <div class="card-body">
        <h2 class="card-title">Paid</h2>
        <form [formGroup]="form">
            <div class="form-group">
                <input type="search" id="find-receipt" class="form-control form-control-sm" formControlName="number"
                    autocomplete="off" placeholder="Find receipt by #" />
            </div>
        </form>
    </div>
    <ul class="list-group list-group-flush pay-list">
        @if ((!payments || (payments.length <= 0))) { 
        <li class="list-group-item">No recent payments at this time.</li>
        }
            
        @for (payment of payments; track payment) {
        <li class="list-group-item" (click)="selected($event, payment)">
            @if (!payment.url) {
            <span class="material-icons">{{icon(payment.category)}}</span>
            }
            @if (payment.url) {
            <img [src]="payment.url" />
            }
            <div class="due">
                <p class="title">{{payment.received | date:'M/d'}}</p>
                @if (payment.daysLate > 0) {
                <p class="subtitle text-truncate" [class.text-warning]="payment.daysLate < 15" [class.text-danger]="payment.daysLate >= 15">{{payment.daysLate}}d late</p>
                }
            </div>
            <div>{{payment.number}}</div>
            @if (!contactId || (contactId <= 0)) {
            <div class="text-truncate">
                <p class="title">{{payment.contact}}</p>
                <p class="subtitle">{{payment.stock}} {{payment.vehicle}}</p>
            </div>
            }
            @if (contactId && (contactId > 0)) {
            <div class="text-truncate">
                <p class="title">{{payment.stock}} {{payment.vehicle}}</p>
                <p class="subtitle">{{payment.source | lowercase}} with {{payment.method | lowercase}}</p>
            </div>
            }
            <div class="currency">
                <p title="principal {{payment.principal | currency}} | interest {{payment.interest | currency}} | tax {{payment.tax | currency}}">
                    @if (payment.category.toLowerCase() !== 'reversal') {
                    <span>{{payment.amount | currency}}</span>
                    }
                    @if (payment.category.toLowerCase() === 'reversal') {
                    <span class="text-danger">{{(payment.amount * -1) | currency}}</span>
                    }
                </p>
                <p class="text-truncate subtitle">{{payment.category | lowercase}}</p>
            </div>
        </li>
        }
    </ul>
</div>

<receipt [id]="receiptId" (closed)="receiptClosed($event)"></receipt>